import React from 'react'
import { Link } from 'react-router-dom';

import { AiOutlineCalendar } from 'react-icons/ai';

import { Container } from './Home_Styles';

import Viviane from '../../assets/Viviane.png';
import Patrocinadores from '../../assets/Patrocinadores.png'
import Patrocinadores2 from '../../assets/Patrocinadores2.png'
import Apoio from '../../assets/Apoio.png'
import Parceiros from '../../assets/Parceiros.png'

import 'custom-react-accordion/dist/Accordion.css';


export default function Home() {

  return (
    <Container>
      <header>
        <div>
          <strong><span>4º</span> ExpoPrev<br/>&<span>2º</span> AGOPREV</strong>
          <br/>
          <h3>Encontro de Gestores, Conselheiros e Servidores Públicos abordando temas atuais e fatos relevantes na área de RPPS.</h3>
          <br />
          <h3>
            <AiOutlineCalendar size={25} /> Dias 05, 06 e 07 de julho
          </h3>
          <br />
          <div>
            <button type="button">
              <Link to="/inscricao"> QUERO ME INSCREVER AGORA</Link>
            </button>
          </div>
        </div>
        <aside>
          <img src={Viviane} alt='ExpoPrev'/>
        </aside>
      </header>
      <content>
        <div>
          <br/>
          <h1>
            Venha participar do nosso evento
          </h1>
          <br/>
          <h3>
            Compartilhe experiências com dirigentes e técnicos de diversos setores da Previdência Social 
            e especialistas em investimentos. Não perca essa oportunidade.<br/>
            A Secretaria de Previdência fará atendimento presencial no decorrer de todo o evento sobre DAIR, DIPR, GESCON, SIG, DRAA, DPIN, Certificação Profissional, Pró-Gestão.
          </h3>
        </div>
        <br/>
        <br/>
        <br/>
        <div>
          <h1>
            Patrocinadores
          </h1>
          <img src={Patrocinadores} alt='Patrocinadores'/>
          <img src={Patrocinadores2} alt='Patrocinadores 2'/>
        </div>
        <div>
          <h1>
            Apoio
          </h1>
          <img src={Apoio} alt='Apoio'/>
        </div>
        <div>
          <h1>
            Parceiros
          </h1>
          <img src={Parceiros} alt='Parceiros'/>
        </div>
        <div>
          <br/>
          <h1>
            Possui alguma dúvida?
          </h1>
          <br/>
          <h3>
            Em caso de dúvidas, basta entrar em contato pelo (62) 99609-0413 ou enviar para contato@expoprev.com.br.
          </h3>
        </div>
      </content>
    </Container>
  );
}
